import React from 'react';
import './terms.css';

function TermsAndConditions() {
  return (
    <div className="terms-container">
      <h1>Terms & Conditions</h1>

      <section className="terms-section">
        <h2>1. Introduction</h2>
        <p>
          Welcome to the <strong>Eye Care Digital Library</strong>. By accessing and using our platform, you agree to comply with the following terms and conditions. If you do not agree, please refrain from using our services.
        </p>
      </section>

      <section className="terms-section">
        <h2>2. User Accounts & Registration</h2>
        <ul>
          <li>Users must provide accurate and complete information during registration.</li>
          <li>Account credentials should be kept secure. Users are responsible for all activities under their account.</li>
          <li>We reserve the right to suspend or terminate accounts found violating our policies.</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>3. Use of Digital Resources</h2>
        <p>The Eye Care Digital Library provides access to e-books, journal articles, theses, and clinical resources.</p>
        <ul>
          <li>Resources are for educational and research purposes only.</li>
          <li>Users must not reproduce, distribute, or sell any content without proper authorization.</li>
          <li>Plagiarism and unauthorized use of materials are strictly prohibited.</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>4. Contributor Policy</h2>
        <p>Users can contribute resources such as e-books, research articles, and journal papers. Contributors must:</p>
        <ul>
          <li>Ensure the content is original or has proper rights/permissions for distribution.</li>
          <li>Avoid submitting plagiarized or copyrighted material without authorization.</li>
          <li>Agree that their contributions may be used within the library under a non-exclusive license.</li>
        </ul>
        <p>Contributors earn points for their submissions, which can be redeemed as per our reward program.</p>
      </section>

      <section className="terms-section">
        <h2>5. Content Moderation & Removal</h2>
        <p>We reserve the right to review, edit, or remove content that:</p>
        <ul>
          <li>Violates copyright laws or intellectual property rights.</li>
          <li>Contains false, misleading, or inappropriate information.</li>
          <li>Is reported by users for non-compliance with our guidelines.</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>6. User Conduct</h2>
        <p>By using our platform, users agree to:</p>
        <ul>
          <li>Respect intellectual property rights and fair use policies.</li>
          <li>Refrain from engaging in cyberattacks, data breaches, or malicious activities.</li>
          <li>Use respectful language and avoid offensive or harmful communication.</li>
        </ul>
      </section>

      <section className="terms-section">
        <h2>7. Limitation of Liability</h2>
        <p>
          The Eye Care Digital Library is not responsible for any damages resulting from the misuse of content. We do not guarantee absolute accuracy or completeness of the information provided.
        </p>
      </section>

      <section className="terms-section">
        <h2>8. Third-Party Links</h2>
        <p>
          Our platform may include links to external websites. We are not responsible for the content, privacy policies, or practices of third-party sites.
        </p>
      </section>

      <section className="terms-section">
        <h2>9. Changes to Terms & Conditions</h2>
        <p>
          We reserve the right to update these Terms & Conditions at any time. Users will be notified of significant changes.
        </p>
      </section>

      <section className="terms-section">
        <h2>10. Contact Us</h2>
        <p>If you have any questions, please contact us at: <a href="mailto:eyecaredigitallibrary@gmail.com">eyecaredigitallibrary@gmail.com</a> or visit our <a href="/contactus">Contact Us</a> page.</p>
      </section>


    </div>
  );
}

export default TermsAndConditions;
